import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import CancellationPolicyService from '../../api/services/CancellationPolicyService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const AddCancellationPackagesItem = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("")
  const [packages, setPackage] = useState([]);
  const [isLoading, setisloading] = useState(true);
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
      getPackage();
    }
    else {
      navigate('/')
    }

  }, []);
  const getPackage = async () => {
    try {
      let packages = await CancellationPolicyService.index().json();
      setPackage(packages.data);
      setisloading(false);
    } catch (error) {
      console.log(error);
    }

  };
  const onSubmitForm = async (event) => {
    event.preventDefault();
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "cancellation_policy_id": event.target.package_id.value
      }
      let responseData = await CancellationPolicyService.can_store(userData).json()
      if (responseData.status === true) {
        navigate("/admin/cancellation-policy-items");
      }
    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  return (
    <>
      <MainPagetitle mainTitle="Add Cancellation Policy Item" pageTitle={'Add Cancellation Policy Item'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add  Cancellation Policy Item</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmitForm}>
                  <div className="row">
                    {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Packages List<span className="text-danger">*</span></label>
                      <select className="form-control" id="val-skill" name="package_id">
                        {packages.map((row, index) =>
                          <option key={index} value={row.id}>{row.title} </option>
                        )}
                      </select>

                    </div>
                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                    {/* <Link to={"#"} onClick={()=>setAddEmploye(false)} className="btn btn-danger light ms-1">Cancel</Link> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
    </>
  );
};
export default AddCancellationPackagesItem;